import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { confirmAlert } from 'react-confirm-alert';

//components
import withLocalization from '~/hoc/withLocalization';
import SwitchWidget from '../../SwitchWidget';
import { DaysOfWeekWidget } from '../../../../../components/GenericForm/Widgets/DaysOfWeekWidget';

//elements
import { NumberInput, Input } from '../../../../../elements/Input';


//utils
import { currentYearCycle } from '../../../../../utils/commonMethods';
import { CLIENT_RULE_CHANGE_VALIDATORS } from '../../../../../utils/constants.js';

class VacationRules extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const Vacation_setup = Object.assign({}, currentEntity.client.data.Vacation_setup);
        this.state = {
            standared_vacation_days: Vacation_setup.standared_vacation_days,
            default_holidays_for_vacation: Vacation_setup.default_holidays_for_vacation,
            enable_default_holidays_for_absence: Vacation_setup.enable_default_holidays_for_absence,
            eligible_age_for_extra_vacations: Vacation_setup.eligible_age_for_extra_vacations,
            extra_vacation_days: Vacation_setup.extra_vacation_days,
            allow_carry_forward_vacation: Vacation_setup.allow_carry_forward_vacation || false,
            max_carry_forward_vacation_limit: Vacation_setup.max_carry_forward_vacation_limit,
            isVacationEditable: false,
        }
        this.handleUserDataChange = this.handleUserDataChange.bind(this);
        this.handleDayChanges = this.handleDayChanges.bind(this);
    }

    handleUserDataChange = (name, value) => {
        const { currentEntity } = this.props.clientStore;
        let Vacation_setup = { ...this.state };
        Vacation_setup[name] = value;
        currentEntity.client.data.Vacation_setup = Vacation_setup;
    }

    handleDayChanges = (days) => {
        const { commonStore, t } = this.props;
        if (!days) {
            commonStore.addNotification(t('All weekdays will be considered while calculating vacations'), null, 'warning');
            this.setState({ default_holidays_for_vacation: days, enable_default_holidays_for_absence: false },
                () => {
                    this.handleUserDataChange('default_holidays_for_vacation', days);
                    this.handleUserDataChange('enable_default_holidays_for_absence', false);
                });
        }
        else
            this.setState({ default_holidays_for_vacation: days },
                () => this.handleUserDataChange('default_holidays_for_vacation', days))
    }

    handleVacationEdit = async () => {
        const { commonStore, clientStore, t } = this.props;
        try {
            const res = await clientStore.validateClientRuleChange({ changeType: CLIENT_RULE_CHANGE_VALIDATORS.VACATION_SETTINGS }, 'vacation');
            const { hasError, message } = res;
            if (hasError) return commonStore.addNotification(t(message), null, 'error', 'top-right', 3000);
            this.setState({ ...this.state, isVacationEditable: true });
        }
        catch (error) {
            console.error(error);
        }
    }

    handleAllowCarryForwardChange = (checked) => {
        if (checked) {
            confirmAlert({
                title: this.props.t('Are You Sure'),
                message: this.props.t("By enabling, the remaining vacation days at the end of the year will be carried forward to the next year and cannot be deleted, Do you want to proceed?"),
                buttons: [
                    {
                        label: this.props.t('Yes'),
                        onClick: () => {
                            this.setState({ allow_carry_forward_vacation: checked },
                                () => this.handleUserDataChange('allow_carry_forward_vacation', checked))
                        },
                    },
                    {
                        label: this.props.t('No'),
                        onClick: () => {
                        },
                    },
                ],
            })
        } else {
            this.setState({ allow_carry_forward_vacation: checked },
                () => this.handleUserDataChange('allow_carry_forward_vacation', checked))
        }
    }

    render() {
        const { t, commonStore } = this.props;
        const { standared_vacation_days, default_holidays_for_vacation, enable_default_holidays_for_absence,
            eligible_age_for_extra_vacations, extra_vacation_days, allow_carry_forward_vacation, max_carry_forward_vacation_limit } = this.state;
        const dateTimeRules = commonStore.getDateTimeRules();
        const { short_date_format } = dateTimeRules;
        const timezoneGMT = commonStore?.config?.timezoneGMT || 0;
        return (
            <>
                <Row className='mt-2'>
                    <Col md={3}>
                        <label className="control-label font-size-15 mt-2 font-color-primary">{t('Standard vacation settings')}</label>
                    </Col>
                    <Col >
                        <OverlayTrigger
                            placement="left"
                            overlay={
                                <Tooltip id="Edit-IASickLeaves">
                                    {t("Enable edit mode")}
                                </Tooltip>
                            }
                        >
                            <i
                                className="fa fa-edit mt-2 font-size-15 cursor-pointer font-color-primary"
                                onClick={this.handleVacationEdit}
                            />
                        </OverlayTrigger>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col xs={6}>
                        <Row className='align-items-center mb-1'>
                            <Col xs={5}>
                                <label className="control-label">{t('Vacation Cycle')}</label>
                            </Col>
                            <Col xs={7}>
                                <Input
                                    name="vacation_cycle"
                                    disabled
                                    onChange={_ => { }}
                                    value={currentYearCycle(short_date_format, timezoneGMT)}
                                />
                            </Col>
                        </Row>
                        <Row className='align-items-center mb-1'>
                            <Col xs={8}>
                                <label className="control-label">{t('Eligible age for extra vacations')}</label>
                            </Col>
                            <Col xs={4}>
                                <NumberInput
                                    name="eligible_age_for_extra_vacations"
                                    value={eligible_age_for_extra_vacations}
                                    disabled={!this.state.isVacationEditable}
                                    onChange={evt => {
                                        const days = parseInt(evt.target.value, 10)
                                        this.setState({ eligible_age_for_extra_vacations: days },
                                            () => this.handleUserDataChange('eligible_age_for_extra_vacations', days))
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row className='align-items-center mb-1'>
                            <Col xs={8}>
                                <label className="control-label">{t('Extra vacation days')}</label>
                            </Col>
                            <Col xs={4}>
                                <NumberInput
                                    name="extra_vacation_days"
                                    value={extra_vacation_days}
                                    disabled={!this.state.isVacationEditable}
                                    onChange={evt => {
                                        const days = parseInt(evt.target.value, 10)
                                        this.setState({ extra_vacation_days: days },
                                            () => this.handleUserDataChange('extra_vacation_days', days))
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6}>
                        <Row className='align-items-center mb-1'>
                            <Col xs={5}>
                                <label className="control-label">{t('Standard vacation days')}</label>
                            </Col>
                            <Col xs={7}>
                                <NumberInput
                                    name="standared_vacation_days"
                                    value={standared_vacation_days}
                                    disabled={!this.state.isVacationEditable}
                                    onChange={evt => {
                                        const days = parseInt(evt.target.value, 10)
                                        this.setState({ standared_vacation_days: days },
                                            () => this.handleUserDataChange('standared_vacation_days', days))
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row className='align-items-center mb-1'>
                            <Col xs={5}>
                                <label className="control-label">{t('Allow carry forward to next year')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If enabled then remaining vacation days at the end of the year will be carry forward to next year")}
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-2" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={5}>
                                <SwitchWidget
                                    value={allow_carry_forward_vacation}
                                    onChange={checked => this.handleAllowCarryForwardChange(checked)}
                                />
                            </Col>
                        </Row>

                        <Row className='align-items-center mb-1'>
                            <Col xs={5}>
                                <label className="control-label">{t('Carry forward limit')}</label>
                            </Col>
                            <Col xs={7}>
                                <NumberInput
                                    name="max_carry_forward_vacation_limit"
                                    value={max_carry_forward_vacation_limit}
                                    disabled={!allow_carry_forward_vacation}
                                    onChange={evt => {
                                        const days = parseInt(evt.target.value, 10)
                                        this.setState({ max_carry_forward_vacation_limit: days },
                                            () => this.handleUserDataChange('max_carry_forward_vacation_limit', days))
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <hr />

                <Row className='my-4'>
                    <label className="control-label">{t('Default holidays')}</label>
                    <DaysOfWeekWidget
                        value={default_holidays_for_vacation}
                        onChange={this.handleDayChanges}
                    />
                </Row>
                <Row className="mb-2">
                    <Col className="mt-1" sm={1}>
                        <SwitchWidget
                            value={enable_default_holidays_for_absence}
                            disabled={!default_holidays_for_vacation}
                            onChange={checked => {
                                this.setState({ enable_default_holidays_for_absence: checked },
                                    () => {
                                        this.handleUserDataChange('enable_default_holidays_for_absence', checked);
                                        if (!checked && this.props.clientStore.currentEntity.client.data.basicRules) {
                                            this.props.clientStore.currentEntity.client.data.basicRules.allowDefaultHolidaysOnMedicalLeave = false;
                                        }
                                    })
                            }}
                        />
                    </Col>
                    <Col sm={10}>
                        <label className="control-label">{t('Allow default holidays on Absence')}</label>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id="tooltip-top">
                                    {t("If enabled the default holidays will not be considered while calculating the total absence days")}
                                </Tooltip>
                            }
                        >
                            <i className="fa fa-info-circle text-muted ms-2" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                        </OverlayTrigger>
                    </Col>
                </Row>
            </>
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(VacationRules)));
